import ElectronicSealAPIContent from "../../../../src/pages/pricing/contact/sales/seal/e-seal-api-content.md";
import { ElectronicSealAPI } from "../../../../src/components/electronicSealForm";
import * as React from 'react';
export default {
  ElectronicSealAPIContent,
  ElectronicSealAPI,
  React
};